import React, { useEffect, useRef, useState } from 'react';
import Titel from '../Titel';
import { Pagination } from "@nextui-org/react";
import { Link } from 'react-router-dom';
import { AxiosPublic, BaseURL } from "../../../config/axios";

const BlogList = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const [blogs, setBlogs] = useState([])
    const pagination = useRef()

    const [loading, setLoading] = useState(true)


    useEffect(() => {
        const get = async () => {
            await AxiosPublic.get(`blog?page=${currentPage}`)
                .then(({ data }) => {
                    const { data: Data } = data
                    setBlogs(Data.data)
                    pagination.current = Data ? Math.ceil(Data.total / Data.per_page) : 1
                })
                .catch(err => alert(err.response?.data.message || 'مشکلی رخ داده است'))
                .finally(() => setLoading(false))
        }
        get()
    }, [currentPage]);

    return (
        <>
            <div className="">
                <Titel title='بلاگ ها' className="md:text-xl" />
                {loading ? <p className="text-center text-xl mt-4">... درحال بارگزاری</p> : <main className="overflow-hidden my-4" dir="rtl">
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 grid-cols-1 gap-3">
                        {blogs.map((s, i) => (
                            <div className="bg-[#f6f6f6] flex flex-col items-center overflow-hidden sm:rounded-lg" key={s.id}>
                                <div className="grow w-full border-b">
                                    <div className="max-h-[250px] h-full overflow-hidden centerOfParent">
                                        <img
                                            className="object-contain w-full h-full max-h-[250px]"
                                            src={BaseURL + s.images[0]?.path} title={s.title}
                                            alt={s.title} placeholder='blur' blurDataURL='/images/placeholder-1.png'
                                            width={0} height={0} sizes="100vw"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-col items-center p-2 w-full">
                                    <h3 className="w-full  font-bold text-center line-clamp-3">
                                        {s.title}
                                    </h3>
                                    <div className="flex items-center gap-2">
                                        <Link
                                            to={`/blogs/${s.slug}`}
                                            className="border-primary border px-2 py-1 mt-2 rounded-md hover:opacity-80">
                                            <svg className='w-4 h-4' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"></path><path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"></path></svg>
                                        </Link>
                                        <Link
                                            to={`/admin/blog?tab=edit&id=${s.id}`}
                                            className="border-primary border px-2 py-1 mt-2 rounded-md hover:opacity-80">
                                            <svg className='w-4 h-4' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z"></path></svg>
                                        </Link>
                                        <Link
                                            to={`/admin/blog?tab=delete&id=${s.id}`}
                                            className="border-primary border px-2 py-1 mt-2 rounded-md hover:opacity-80">
                                            <svg className='w-4 h-4' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path><path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path></svg>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div dir="auto" className="centerOfParent mt-4">
                        {!!blogs.length && pagination.current > 1 &&
                            <Pagination size='sm'
                                total={Math.ceil(pagination.current)}
                                color="primary"
                                page={Number(currentPage)}
                                onChange={setCurrentPage}
                                showControls
                            />}
                    </div>
                </main >}
            </div>
        </>
    );
};

export default BlogList;